import { Button, Tooltip } from "flowbite-react";
import { HiUserRemove } from "react-icons/hi";
import { Client, DataGridPagination } from "@/sharedTypes";
import DataTable from "../Table";
import { useTranslation } from "react-i18next";
import { useCurrentUser } from "@/hooks/useCurrentUser";
import { isCompanyAdminUser } from "@/constants/agent";

interface ClientGroupClientsTableProps {
  data: Client[];
  pagination: DataGridPagination;
  onPageChange: (page: number) => void;
  onRemoveClient: (clientId: number) => void;
  loading?: boolean;
}

const ClientGroupClientsTable = ({
  data,
  pagination,
  onPageChange,
  onRemoveClient,
}: ClientGroupClientsTableProps) => {
  const { t } = useTranslation(["clientGroup"]);
  const user = useCurrentUser();
  const isAdmin = isCompanyAdminUser(user);

  const columns = [
    { key: "client_username", label: t("clientGroup:clientUsername") },
    { key: "client_email", label: t("clientGroup:clientEmail") },
    { key: "client_phone", label: t("clientGroup:clientPhone") },
    ...(isAdmin
      ? [
          {
            key: "actions",
            label: t("clientGroup:actions"),
            render: (row: Client) => (
              <Tooltip content={t("clientGroup:unassign")}>
                <Button
                  color="light"
                  size="xs"
                  onClick={() => row.client_id && onRemoveClient(row.client_id)}
                >
                  <HiUserRemove className="h-4 w-4 text-red-500" />
                </Button>
              </Tooltip>
            ),
          },
        ]
      : []),
  ];

  return (
    <DataTable
      columns={columns}
      data={data}
      pagination={pagination}
      onPageChange={onPageChange}
    />
  );
};

export default ClientGroupClientsTable;
